import { __assign, __rest } from "tslib";
import createToolbar from './toolbar';
import { createBasePlugin } from 'wix-rich-content-editor-common';
import { GALLERY_TYPE, getDefaultComponentData } from './types';
import galleryComponentWrapper from './components/GalleryComponentWrapper/gallery-component-wrapper';
import BadPlugin from '../../components/BadPlugin';
function galleryPluginCreator(pluginConfig) {
    return function (config) {
        var _a;
        if (config === void 0) { config = {}; }
        var decorator = config.decorator, helpers = config.helpers, t = config.t, theme = config.theme, isMobile = config.isMobile, anchorTarget = config.anchorTarget, relValue = config.relValue, gallery = config.gallery, rest = __rest(config, ["decorator", "helpers", "t", "theme", "isMobile", "anchorTarget", "relValue", "gallery"]);
        return createBasePlugin(__assign({ component: pluginConfig.component
                ? galleryComponentWrapper(pluginConfig.component)
                : BadPlugin, decorator: decorator, settings: __assign(__assign(__assign({}, gallery), pluginConfig), { defaultLayout: (_a = config['Gallery']) === null || _a === void 0 ? void 0 : _a.defaultLayout }), theme: theme, type: GALLERY_TYPE, toolbar: createToolbar({
                helpers: helpers,
                t: t,
                pluginConfig: pluginConfig,
            }), helpers: helpers,
            isMobile: isMobile,
            anchorTarget: anchorTarget,
            relValue: relValue,
            t: t, defaultPluginData: getDefaultComponentData() }, rest), {});
    };
}
export { galleryPluginCreator };
//# sourceMappingURL=createGalleryPlugin.js.map